import React from 'react'
import {Typography, Button, Card, CircularProgress} from '@material-ui/core'
import {Mutation, Query} from 'react-apollo'
import update from 'immutability-helper'
import {toast} from 'react-toastify'
import SynonymTable from './SynonymTable'
import NestedSynonymCard from './NestedSynonymCard'
import {requireAuthAndProject} from '../../../../../auth'
import {FusePageCarded} from '../../../../../@fuse'
import {getSynonyms, updateSynonyms} from '../../../../../functions/ecommerce'
import FaqSection from './faq'
import AutoResume from './component/AutoResume'
import {GET_BOT_TIMER} from '../../../../../graphql/query'
import {UPDATE_BOT_TIMER} from '../../../../../graphql/mutation'

class AISettingPage extends React.Component {
  state = {
    loading: true,
    updating: false,
  }

  async componentDidMount() {
    const resp = await getSynonyms(this.props.project.id)
    this.setState({
      loading: false,
      ...resp.data,
    })
  }

  onNewTag = newTagImmutabilityHelperQuery => {
    const newState = update(this.state, newTagImmutabilityHelperQuery)
    this.setState(newState)
  }

  onSave = async () => {
    const {PRODUCT_NAME, PRODUCT_BRAND, CATEGORY, SKU, PROPERTY} = this.state
    this.setState({updating: true})
    await updateSynonyms(this.props.project.id, {
      PRODUCT_NAME,
      PRODUCT_BRAND,
      CATEGORY,
      SKU,
      PROPERTY,
    })
    toast.success('AI updated', {
      position: toast.POSITION.BOTTOM_RIGHT,
    })
    this.setState({updating: false})
  }

  render() {
    const header = (
      <div className="flex items-center p-8 md:p-24">
        <img
          style={{
            width: '50px',
          }}
          className="text-32 mr-12"
          alt=""
          src="./assets/images/deeple/5_ai_setting_white.png"
        />
        <Typography variant="title">AI Settings</Typography>
      </div>
    )

    const content = this.state.loading ? (
      <div
        style={{
          paddingTop: 30,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress size={150} />
      </div>
    ) : (
      <div style={{padding: 24}}>
        <Query
          query={GET_BOT_TIMER}
          variables={{ projectId: this.props.project.id}}
        >
          {({loading, error, data}) => {
            if (loading) return 'loading'
            if (error) return 'error'
            return (
              <Mutation
                mutation={UPDATE_BOT_TIMER}
                refetchQueries={[
                  {
                    query: GET_BOT_TIMER,
                    variables: {
                      projectId: this.props.project.id,
                    },
                  },
                ]}
              >
                {updateBotTimer => {
                  return (
                    <AutoResume
                      onSave={updateBotTimer}
                      value={data.getBotTimer}
                      projectId={this.props.project.id}
                    />
                  )
                }}
              </Mutation>
            )
          }}
        </Query>
        <Card style={{padding: '20px', marginBottom: '20px'}}>
          <Typography variant="title" style={{marginBottom: '20px'}}>
            FAQ
          </Typography>
          <FaqSection projectId={this.props.project.id} />
        </Card>
        <Card style={{padding: '20px', marginBottom: '20px'}}>
          <Typography variant="title" style={{marginBottom: '20px'}}>
            Product name
          </Typography>
          <SynonymTable
            data={this.state.PRODUCT_NAME}
            name="PRODUCT_NAME"
            onNewTag={this.onNewTag}
          />
        </Card>
        <Card style={{padding: '20px', marginBottom: '20px'}}>
          <Typography variant="title" style={{marginBottom: '20px'}}>
            Product brand
          </Typography>
          <SynonymTable
            data={this.state.PRODUCT_BRAND}
            name="PRODUCT_BRAND"
            onNewTag={this.onNewTag}
          />
        </Card>
        <Card style={{padding: '20px', marginBottom: '20px'}}>
          <Typography variant="title" style={{marginBottom: '20px'}}>
            Product category
          </Typography>
          <SynonymTable
            data={this.state.CATEGORY}
            name="CATEGORY"
            onNewTag={this.onNewTag}
          />
        </Card>
        <NestedSynonymCard
          title="Product SKU"
          name="SKU"
          data={this.state.SKU}
          onNewTag={this.onNewTag}
        />
        <NestedSynonymCard
          title="Product property"
          name="PROPERTY"
          data={this.state.PROPERTY}
          onNewTag={this.onNewTag}
        />
        <Button
          disabled={this.state.updating}
          onClick={this.onSave}
          style={{background: '#663EE8', color: '#F9FDFF'}}
        >
          Update
        </Button>
      </div>
    )

    return <FusePageCarded header={header} content={content} innerScroll />
  }
}

export default requireAuthAndProject(AISettingPage)



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/aiSetting/AISettingPage.js